import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading } = useContext(AuthContext);

	if (loading) {
		return <BackdropLoading />;
	}

	if (!isAuth && isPrivate) {
		// Fix 2026-09-21: "rest.location" nunca vem preenchido (ninguem passa
		// esse prop pro <Route>), entao "from" sempre chegava undefined no
		// Login - por isso paginas standalone tipo /senha-tecnica pediam
		// login e depois caiam direto em /tickets em vez de voltar pra onde
		// o usuario tentou entrar. window.location.pathname e' a rota real.
		return (
			<Redirect
				to={{ pathname: "/login", state: { from: { pathname: window.location.pathname } } }}
			/>
		);
	}

	if (isAuth && !isPrivate) {
		return <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
	}

	return <RouterRoute {...rest} component={Component} />;
};

export default Route;
